export default [
  {
    key: 'data',
    label: 'Data',
    sortable: true,
  },
  {
    key: 'usuario',
    label: 'Usuário',
    sortable: true,
  },
  {
    key: 'campo',
    label: 'Campo',
    sortable: true,
  },
  {
    key: 'de',
    label: 'De',
    sortable: true,
  },
  {
    key: 'para',
    label: 'Para',
    sortable: true,
  },
]
